<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <!-- start page title -->
  <div class="mw-100 mx-auto mx-lg-0">
      <div class="page-title-box d-flex align-items-center justify-content-center align-items-lg-start">
        <h4 class="my-1 font-size-18">{{ title }}</h4>
      </div>
    </div>
  <!-- end page title -->
</template>
<style scoped>

</style>